import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

export interface LaikaChatFabProps {
  onOpen: () => void;
  ariaLabel: string;
}

/** FAB visible lorsque le chat Laika est fermé (styles `.chat-bubble-modern`). */
const LaikaChatFab = forwardRef<HTMLButtonElement, LaikaChatFabProps>(
  ({ onOpen, ariaLabel }, ref) => (
    <motion.button
      ref={ref}
      type="button"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0, opacity: 0 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      onClick={onOpen}
      className="chat-bubble-modern laika-trigger"
      aria-label={ariaLabel}
    >
      <div className="chat-bubble-icon">
        <Sparkles size={28} strokeWidth={2.25} aria-hidden />
        <span className="chat-bubble-pulse">
          <span className="chat-bubble-pulse-ring" />
          <span className="chat-bubble-pulse-dot" />
        </span>
      </div>
      <motion.div
        animate={{ scale: [1, 1.5, 1], opacity: [0.5, 0, 0.5] }}
        transition={{ duration: 2, repeat: Infinity }}
        className="chat-bubble-pulse-effect"
        aria-hidden
      />
    </motion.button>
  )
);

LaikaChatFab.displayName = 'LaikaChatFab';

export default LaikaChatFab;
